var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGqShap2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 47,
    viewBox: "0 0 41 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4962 46.8716L38.1384 46.3901C23.7121 41.1436 14.2182 37.3332 8.47044 33.3686C0.16818 27.6421 0.656108 22.1288 1.28866 20.022C2.34317 16.3376 6.04321 13.7062 10.5287 13.4933C13.5956 13.3581 16.9597 14.8417 19.6838 16.7937C17.8996 7.73078 20.7842 2.70065 24.3928 1.03798C28.2115 -0.764221 32.8838 0.931107 35.7442 5.17091C42.0532 14.4705 40.8815 29.4326 39.8324 42.6267L39.4962 46.8716ZM6.03803 17.0825C4.71811 17.9595 3.7473 19.1667 3.35553 20.5946C2.34129 24.0793 4.65268 28.0785 9.69189 31.5625C15.1004 35.2768 24.0052 38.9165 37.533 43.8519L37.635 42.4436C38.6127 30.2482 39.8047 15.0565 33.9143 6.3868C31.6718 3.07694 28.1078 1.68295 25.2988 2.98724C22.2299 4.42099 19.6748 9.62146 22.5266 19.4452L23.7091 23.5026L20.7269 20.5113C18.2833 18.0702 14.0718 15.5065 10.5853 15.661C8.877 15.7583 7.29796 16.2453 6.03803 17.0825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGqShap2);
export default __webpack_public_path__ + "static/media/gq-shap-2.8dd8349e2e289ca364c895dee21890c7.svg";
export { ForwardRef as ReactComponent };